/*
 * @Date: 2019-08-21 17:01:53
 * @LastEditors: pppp pppp@gmail.com
 * @LastEditTime: 2024-10-18 14:33:17
 */
import api from './api'

const url = 'account'
export default {
  // 支付信息
  getSuport() {
    return api.get(`${url}/Suport`)
  },
  // 登陸
  sendLogin(data) {
    return api.post(`${url}/SignLogin`, data)
  },
  // 注冊
  sendRegister(data) {
    return api.post(`${url}/SignRegister`, data)
  },
  // 注冊時發送驗證碼
  sendSignRegisterSendSms(data) {
    return api.post(`${url}/SignRegisterSendSms`, data)
  },
  // 校验手机号是否注册
  sendCheckTelHadRegister(data) {
    return api.post(`${url}/CheckTelHadRegister`, data)
  },
  //找回密碼發送驗證碼
  sendSignFindPwdSendSms(data) {
    return api.post(`${url}/SignFindPwdSendSms`, data)
  },
  //找回密碼
  sendSignFindPwd(data) {
    return api.post(`${url}/SignFindPwd`, data)
  },
  //注冊是否顯示圖形驗證碼
  getSignRegisterNeedVerCode() {
    return api.get(`${url}/SignRegisterNeedVerCode`)
  },
  //校驗圖形驗證碼
  getCheckVerificationCode(verCode, verId) {
    return api.get(`${url}/CheckVerificationCode?verCode=${verCode}&verId=${verId}`)
  },
  // 檢查是否登陸
  getIsLogin() {
    return api.get(`${url}/IsLogin`)
  },
  /**
 * @description: 检验是否购买和安装签包文件
 * @param 证书记录和购买成功记录
 * @param 0未登录
 * @param 1未购买
 * @param 2已购买没安装
 * @param 3已购买已安装
 * @return: 
 */
  getCheckCerOrderState() {
    return api.get(`${url}/CheckCerOrderState`)
  },
  /**
   * @description: 缓存用户名和密码及返回键值
   * @return: 
   */
  getUserKey() {
    return api.get(`${url}/GetUserKey`)
  },
  /**
   * @description: tokenLogin 
   * @return: 
   */
  sendTokenLogin(token) {
    return api.post(`${url}/token`, { token: token })
  }
}
/**
  * @description: 是否有Udid
  * @param {*}
  * @return {*}
  */
const getIsHadUdid = () => {
  return api.get(`${url}/IsHadUdid`)
}
/**
 * @description: 是否有签发记录
 * @param {*}
 * @return {*}
 */
const getIsHadSignRecord = () => {
  return api.get(`${url}/IsHadSignRecord`)
}
/**
 * @description: 根据用户信息查询激活码，购买时间等
 * @param {*}
 * @return {*}
 */
const getDownCodeList = (phone = "", isUdid = true) => {
  return api.get(`${url}/GetDownCodeList?phone=${phone}&isUdid=${isUdid}`)
}
/**
 * @description: 检测是否有激活码
 * @param {*}
 * @return {*}
 */
const getCheckHadDownCode = () => {
  return api.get(`${url}/CheckHadDownCode`)
}
/**
 * @description: 有签发记录，通过订单号查询订单激活码
 * @param {orderNum} 不传就查此设备 传就查此订单
 * @return {*}
 */
const getSignDownCode = ({orderNum="",appCode="CHXH"}={}) => {
  return api.get(`${url}/GetSignDownCode?orderNum=${orderNum}&appCode=${appCode}`)
}
export {
  getIsHadUdid,
  getIsHadSignRecord,
  getDownCodeList,
  getCheckHadDownCode,
  getSignDownCode
}


// WEBPACK FOOTER //
// ./src/api/account.js